<div class="content-wrapper-inner relative">
  <div class="page-content">
    <div class="table-topbar mb-20">
      <div *ngIf="!selectedRows.length" class="search-holder">
        <input placeholder="Search by short code, description or country" type="search" class="form-control table-search" [formControl]="searchControl" />
        <span class="icon-search"></span>
      </div>
      <!-- <div *ngIf="selectedRows.length" class="batch-panel top-panel-data-table">
                    <ng-container *ngIf="!progressShow">
                        <button (click)="onBatchDelete()" type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i> Delete</button>
                        <span class="vertical-line"></span>
                        <button (click)="onBatchEnabled(true)" type="button" class="btn btn-sm btn-primary m-r"><i class="fa fa-check"></i> Enabled</button>
                        <button (click)="onBatchEnabled(false)" type="button" class="btn btn-sm btn-danger"><i class="fa fa-close"></i> Disabled</button>
                    </ng-container>
                    <ng-container *ngIf="progressShow">
                        <progressbar class="progress-striped" [max]="selectedRows.length" [value]="batchCompleted"></progressbar>
                    </ng-container>
                </div> -->
      <div class="table-action-holder">
        <div class="import me-20 cp" (click)="onClickImport()">
          <a><span class="icon-import"></span></a>
        </div>
        <div class="create">
          <button (click)="moShortCodeCreate()" class="btn btn-primary py-10 px-15">
            <span class="icon-add"></span> Create
          </button>
        </div>
      </div>
    </div>
    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-mo-shortcode-table (onSearch)="handleSearch($event)" (changeBatch)="selectedRows = $event"></app-mo-shortcode-table>
      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{selectedRows.length}} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <div class="text-icon-holder" (click)="onBatchToggle(true)">
            <span class="icon">
              <span class="icon-positive"></span>
            </span>
            <span class="text">Enable</span>
          </div>
          <div class="text-icon-holder" (click)="onBatchToggle(false)">
            <span class="icon">
              <span class="icon-negative"></span>
            </span>
            <span class="text">Disable</span>
          </div>
          <div class="text-icon-holder" (click)="onBatchDelete()">
            <span class="icon">
              <span class="far fa-trash-alt"></span>
            </span>
            <span class="text">Delete</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #importModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Import short codes from file</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-mo-shortcode-import (import)="onImport($event)"></app-mo-shortcode-import>
  </div>
</ng-template>
